export enum ViewStateEnum {
  Loading = 'LOADING',
  Ready = 'READY',
  Refreshing = 'REFRESHING',
  Error = 'ERROR',
}